export const PromiseDelay = async () => {
  return await new Promise((resolve) => setTimeout(resolve, 3000));
};
